module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "signup-top"
  }, [_c('p', {
    staticClass: "signup-head"
  }, [_vm._v("Thank you for downloading this Simon & Schuster ebook.")]), _vm._v(" "), _c('p', {
    staticClass: "signup-texttop"
  }, [_vm._v("Get a FREE ebook when you join our mailing list. Plus, get updates on new releases, deals, recommended reads, and more from Simon & Schuster. Click below to sign up and see terms and conditions.")])]), _vm._v(" "), _c('div', {
    staticClass: "signup-middle"
  }, [_c('p', {
    staticClass: "signup-clickhere"
  }, [_c('a', {
    attrs: {
      "href": "https://www.simonandschuster.com/ebook-signup/front/9781501130991",
      "target": "_blank",
      "title": "Simon & Schuster Mailing List Sign-up Link"
    }
  }, [_vm._v("CLICK HERE TO SIGN UP")])])]), _vm._v(" "), _c('div', {
    staticClass: "signup-bottom"
  }, [_c('p', {
    staticClass: "signup-textbottom"
  }, [_vm._v("Already a subscriber? Provide your email again so we can register this ebook and send you more of what you like to read. You will continue to receive exclusive offers in your inbox.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52530b3b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/SS_US_adult_signup_front.vue
// module id = 63
// module chunks = 0